var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormModal',{attrs:{"model":_vm.model,"init":_vm.init,"modal-id":"store","onSetIsEditMode":_vm.onSetIsEditMode},scopedSlots:_vm._u([{key:"form",fn:function(ref){
var error = ref.error;
return [_vm._v("\n"+_vm._s(_vm.model)+"\n        ")]}}])},[[_c('div',{key:_vm.key,staticClass:"d-flex"},[_c('ItemBadges',{staticClass:"mb-1",attrs:{"model":_vm.model}})],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }